export default function FileIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 3C4.79086 3 3 4.79086 3 7V17C3 19.2091 4.79086 21 7 21H12V16C12 13.7909 13.7909 12 16 12H21V7C21 4.79086 19.2091 3 17 3H7ZM20.8122 14H16C14.8954 14 14 14.8954 14 16V20.832C14.3408 20.7299 14.6682 20.5824 14.9728 20.392L15.0783 20.326C17.004 19.1225 18.6515 17.5228 19.9111 15.6333L20.3282 15.0077C20.5371 14.6944 20.6995 14.355 20.8122 14Z"
        fill="#191A19"
        fillOpacity="0.4"
      />
    </svg>
  );
}
